<form (ngSubmit)="onSubmit()" [formGroup]="filterForm">
  <header class="p-1 light-bg light-bottom-border" fxLayoutAlign="space-between center">
    <button (click)="deactivateAll()" mat-raised-button type="reset">
      {{ 'COMMON.delete' | translate }}
    </button>
    <span class="mat-subheading-1 no-pad">{{ 'COMMON.filter' | translate }}</span>
    <button color="accent" mat-raised-button type="submit">
      {{ 'COMMON.done' | translate }}
    </button>
  </header>
  @for (filter of filters; track filter; let i = $index) {
    <recrewt-filter [filter]="filter"
      [frmControlName]="i"
      [frmGroup]="filterForm"
      frmArrayName="filters"
     />
  }
</form>
